<template>
  <!-- Responsive home page layout -->
  <v-app>
    <v-container>
      <v-row justify="center">
        <!-- Navigation Bar -->
        <v-col cols="12" class="mb-8">
          <NavBar pageTitle="Home" />
        </v-col>

        <!-- Loading State -->
        <v-col v-if="isLoading" cols="12" class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-col>

        <!-- Error State -->
        <v-col v-else-if="error" cols="12">
          <v-alert type="error" class="mx-auto" max-width="500">
            {{ error }}
          </v-alert>
        </v-col>

        <template v-else>
          <!-- 1) Current Exercises -->
          <v-col cols="12" md="6" lg="4">
            <ItemList
              sectionHeader="Current Exercises"
              :items="homeData.currentExercises"
            />
          </v-col>

          <!-- 2) Content for You -->
          <v-col cols="12" md="6" lg="4">
            <ItemList
              sectionHeader="Content for You"
              :items="homeData.contentForYou"
            />
          </v-col>

          <!-- 3) Your Favorites -->
          <v-col cols="12" md="6" lg="4">
            <ItemList
              sectionHeader="Your Favorites"
              :items="homeData.favorites"
            />
          </v-col>
        </template>
      </v-row>
    </v-container>

     <!-- Snackbar Alert -->
    <v-snackbar
      v-model="showLoginMessage"
      :timeout="5000"
      color="#ff6d44"
      elevation="3"
      location="bottom"
      class="custom-snackbar"
    >
      You are logged in as a patient.
    </v-snackbar>

    <!-- Footer -->
    <MENDFooter />
  </v-app>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import NavBar from './NavBar.vue';
import MENDFooter from './MENDFooter.vue';
import ItemList from './ItemList.vue';
// import MoodAssessment from './MoodAssessment.vue'; // Optional

export default {
  name: 'HomePage',
  components: {
    NavBar,
    MENDFooter,
    ItemList
    // MoodAssessment
  },
  setup() {
    const homeData = ref({
      currentExercises: [],
      contentForYou: [],
      favorites: [],
    });
    const error = ref('');
    const isLoading = ref(false);
    const showLoginMessage = ref(false);

    const fetchHomeData = async () => {
      try {
        isLoading.value = true;
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        
        // TODO: Get encryptedPatientId from your auth system
        const encryptedPatientId = localStorage.getItem("patientId");
        
        const response = await axios.get(`/api/Homepage/data?encryptedPatientId=${encryptedPatientId}`);
        
        console.log(response.data.currentExercises)

        homeData.value.currentExercises = response.data.currentExercises;
        homeData.value.contentForYou = response.data.contentForYou;
        homeData.value.favorites = response.data.favorites;

        console.log(homeData);

      } catch (err) {
        console.error('Error fetching homepage data:', err);
        error.value = err.response?.status === 400 
          ? 'Missing patient ID' 
          : 'Failed to fetch homepage data';
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
       const userRole = localStorage.getItem("userRole");
if (userRole === 'patient') {
  showLoginMessage.value = true;
}
      fetchHomeData();
    });

    return {
      homeData,
      error,
      isLoading
    };
  },
  methods: {
    goToChatBot() {
      this.$router.push({ name: 'ChatBot' });
    }
  }
};
</script>

<style scoped>
* {
  font-family: 'Montserrat', sans-serif;
}

.flex-box {
  display: flex;
  justify-content: center;
}
</style>
